// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ec1b8688","455":"3851a53a","488":"025780cc","977":"48333931"}[chunkId] + ".chunk.js";
};